import React, { useEffect, useState } from 'react';
import { Accordion, Button, Card } from 'react-bootstrap';
import { findAllRequestForSignetFilterPageable } from '../../../actions/requestForSignetApproval';
import Form from '../../Reusable/Form/Form';
import { config } from './RequestForSignetApprovalConfig';
import withTranslations from '../../../utils/HighOrderComponent';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dot from 'dot-object';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import '../../../styles/scss/app/RequestForSignetForm.scss';
import { userRoles } from '../../../constants/globals.js';
import { findAllPlace } from '../../../actions/place';
import { findAllMunicipality } from '../../../actions/municipality';
import { requestForSignetApprovalStatus } from '../../../constants/globals';
import { checkForUserRole } from '../../../utils';

const RequestForSignetApprovalFilter = ({
  t,
  findAllRequestForSignetFilterPageable,
  saveFilters,
  initialValues,
  initialStateValues,
  savePostData,
  setResetData,
  findAllPlace,
  findAllMunicipality,
  placeList,
  municipalityList,
  loggedUser,
  enums,
  pageSize,
}) => {
  useEffect(() => {
    findAllPlace();
    findAllMunicipality();
  }, [findAllPlace, findAllMunicipality]);

  const { AccordionForm } = t || {};

  const [activeKey, setActiveKey] = useState('-1');
  const placeNameList = placeList?.map((place) => place.name) || [];
  const municipalityNameList =
    municipalityList?.map((municipality) => municipality.name) || [];

  const isAuthorizedPersonLoggedIn = checkForUserRole(
    loggedUser.roles,
    userRoles.AUTHORIZED_PERSON.value
  );

  const isProcessorLoggedIn = checkForUserRole(
    loggedUser.roles,
    userRoles.MDULS.value
  );

  const isInspectorLoggedIn = checkForUserRole(
    loggedUser.roles,
    userRoles.INSPECTOR.value
  );

  let statusList = requestForSignetApprovalStatus;
  if (isProcessorLoggedIn || isInspectorLoggedIn) {
    statusList = requestForSignetApprovalStatus.filter(
      (status) => status.value !== 2
    );
  }

  const { fields } = config(
    t,
    placeNameList,
    municipalityNameList,
    statusList,
    isAuthorizedPersonLoggedIn,
    enums
  );
  const decoratedOnClick = useAccordionToggle('0', () => {
    setActiveKey('-1');
  });

  const handleSubmit = (values) => {
    const dotNotationObj = dot.dot(values);

    const postData = {
      tableName: 'requestForSignetApproval',
      filterCriteria: Object.entries(dotNotationObj)
        .map((entry) => {
          if (entry[0] === 'createdAtFrom' || entry[0] === 'createdAtTo') {
            if (
              values.createdAtFrom !== initialValues.createdAtFrom ||
              values.createdAtTo !== initialValues.createdAtTo
            )
              return {
                columnName: 'createdAt',
                dateMin: values.createdAtFrom,
                dateMax: values.createdAtTo,
                logicalOperator: '><',
              };
          } else if (entry[0].includes('status')) {
            return (
              (values.status?.value || values.status?.value === 0) && {
                columnName: 'status',
                columnValue: values.status.value,
              }
            );
          } else {
            return (
              entry[1] && {
                columnName: entry[0],
                columnValue: entry[1],
              }
            );
          }
          return null;
        })
        .filter((item) => !!item),
    };
    if (postData.filterCriteria?.length === 0) {
      resetFilters();
    } else {
      savePostData(postData);
      findAllRequestForSignetFilterPageable(postData, pageSize, () =>
        saveFilters(values)
      );
    }
  };

  const packConfig = () => {
    return {
      fields: [...fields],
    };
  };

  const packTranslations = () => {
    return {
      ...t,
    };
  };

  const resetFilters = () => {
    savePostData(null);
    setResetData(true);
    return saveFilters(initialStateValues);
  };
  const filterCardStyle =
    activeKey === '0' ? 'form-row card-header-open' : 'form-row';
  return (
    <div className="Filters m-auto">
      <Accordion activeKey={activeKey}>
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            variant="link"
            eventKey="0"
            className={filterCardStyle}
            onClick={() => {
              if (activeKey !== '0') {
                setActiveKey('0');
              } else {
                setActiveKey('-1');
              }
            }}
          >
            <div className="float-left col-md-11">{AccordionForm.title}</div>
            {activeKey === '0' && initialValues !== initialStateValues && (
              <div className="col-md-1 float-right">
                <Button
                  variant="warning"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  {AccordionForm.reset}
                </Button>
              </div>
            )}
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <Card.Body style={{ paddingTop: '-2vh' }}>
              <Form
                className={
                  isAuthorizedPersonLoggedIn ? 'RequestForSignetForm' : 'Form'
                }
                onSubmit={handleSubmit}
                initialValues={initialValues}
                formConfig={packConfig()}
                translations={packTranslations()}
                removeCancel={true}
                submitLabel={AccordionForm.filter}
                decoratedOnClick={decoratedOnClick}
              />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loggedUser: state.loggedUser?.loggedUser,
  placeList: state.place.placeList || [],
  municipalityList: state.municipality.municipalityList || [],
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllRequestForSignetFilterPageable: (
      postData,
      pageSize,
      successCallback
    ) => {
      dispatch(
        findAllRequestForSignetFilterPageable(
          0,
          pageSize,
          postData,
          successCallback
        )
      );
    },
    findAllPlace: () => {
      dispatch(findAllPlace());
    },
    findAllMunicipality: () => {
      dispatch(findAllMunicipality());
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    withTranslations(
      RequestForSignetApprovalFilter,
      'RequestForSignetApprovalFilter'
    )
  )
);
